import {defineAbilityConfig} from '../system/defineAbilityConfig';

/**
 * This ability evaluates whether the user can access page building.
 */
export const pageBuilderAbility = defineAbilityConfig([
  {
    permission: ['build', 'sitePage'],
  },
  {
    // Read-only Preview visitors can use page-building UI locally, while
    // server-enforced playground mode prevents their changes from persisting.
    userTypes: {unauthorized: true},
  },
] as const);

/**
 * Determines whether the user is currently in Build mode (edit mode + page builder ability).
 *
 * This covers all build mode scenarios, including both regular page building
 * and campaign building. For campaign-specific checks, use isInCampaignBuildMode.
 */
export const isInPageBuildMode = defineAbilityConfig({
  siteModes: {edit: true},
  abilities: {pageBuilderAbility: true},
} as const);

/**
 * Determines whether the user can access Page Builder mode.
 * This can be used in design mode to understand whether the current designer has the ability to switch
 * into page builder mode
 */
export const canAccessPageBuildMode = defineAbilityConfig({
  siteModes: {design: true, edit: true},
  abilities: {pageBuilderAbility: true},
} as const);
